import { Button, Flex, Link, Text } from "@chakra-ui/react";
import { ChevronRightIcon } from "@iloq/shared-react/CustomIcons";
import VueContext from "@iloq/shared-react/vueContext";
import { ReactElement, SyntheticEvent, useContext } from "react";
import { FormattedMessage } from "react-intl";
import { CountTag } from "./count-tag";

interface Props {
  titleKey: string;
  count: number | string;
  titleLink: string;
  createKey: string;
  createLink: string;
  isDisabled?: boolean;
  createLinkDisabled?: boolean;
}

function DisabledCreateLink(): ReactElement {
  return (
    <Flex height="40px">
      <Text
        justifyContent="left"
        size={{ base: "sm", lg: "md" }}
        maxWidth={{ base: "140px", lg: "none" }}
        fontWeight="bold"
        textAlign="left"
        paddingX="16px"
        marginY="auto"
        textColor="brand.grayDark"
      >
        &ndash;
      </Text>
    </Flex>
  );
}

export function PartnerStatsLinkButtons({
  titleKey,
  count,
  titleLink,
  createKey,
  createLink,
  isDisabled = false,
  createLinkDisabled = false,
}: Props): ReactElement {
  const context = useContext(VueContext);
  const $router = context.$router;

  if (isDisabled) {
    return (
      <Flex flexDir="column" gap={{ base: "0", lg: "2" }} flex="50%">
        <Flex height="40px">
          <Text
            justifyContent="left"
            size={{ base: "sm", lg: "md" }}
            maxWidth={{ base: "140px", lg: "none" }}
            fontWeight="bold"
            textAlign="left"
            paddingX="16px"
            marginY="auto"
            textColor="brand.grayDark"
          >
            <FormattedMessage id={titleKey} />
          </Text>
        </Flex>

        <DisabledCreateLink />
      </Flex>
    );
  }

  /* React-router links do not work here, I assume because of some Vue Router vs React Router issue.
   * Handle links by pushing to Vue router. */
  return (
    <Flex flexDir="column" gap={{ base: "0", lg: "2" }} flex="50%">
      <Button
        as={Link}
        href={titleLink}
        onClick={(e: SyntheticEvent) => {
          e.preventDefault();
          $router.history?.push(titleLink);
        }}
        variant="partnerLink"
        justifyContent="left"
        size={{ base: "sm", lg: "md" }}
        maxWidth={{ base: "140px", lg: "none" }}
      >
        <Flex flexDir="row" gap="2">
          <Text fontWeight="bold">
            <FormattedMessage id={titleKey} />
          </Text>{" "}
          <CountTag count={count} />
        </Flex>
      </Button>

      {createLinkDisabled ? (
        <DisabledCreateLink />
      ) : (
        <Button
          as={Link}
          href={createLink}
          onClick={(e: SyntheticEvent) => {
            e.preventDefault();
            $router.history?.push(createLink);
          }}
          variant="partnerLink"
          justifyContent="left"
          rightIcon={<ChevronRightIcon />}
          size={{ base: "sm", lg: "md" }}
          maxWidth={{ base: "140px", lg: "none" }}
        >
          <Text fontWeight="normal" textAlign="left">
            <FormattedMessage id={createKey} />
          </Text>
        </Button>
      )}
    </Flex>
  );
}
